import { useEffect, useState } from 'react';
import { api } from './api';

/**
 * 맛보기 (2026-10): 결제 안 한 회원에게 악보 앞부분 + 이번 주 무료 곡. 서버 설정(PREVIEW_ENABLED)으로 켜고 끈다.
 * 꺼져 있으면 enabled=false → 화면은 예전처럼 구독 안내만.
 */
export interface FreeSong {
  id: number;
  title: string;
  singer: string;
  image_url?: string | null;
}
export interface PreviewInfo {
  enabled: boolean;
  rows: number;
  songs: FreeSong[];
}

let cache: Promise<PreviewInfo> | null = null;
export const getPreview = () => {
  if (!cache) {
    cache = api
      .get('/free-songs')
      .then(({ data }) => (data?.data as PreviewInfo) || { enabled: false, rows: 2, songs: [] })
      .catch(() => ({ enabled: false, rows: 2, songs: [] }));
  }
  return cache;
};

export const usePreview = () => {
  const [info, setInfo] = useState<PreviewInfo | null>(null);
  useEffect(() => {
    let alive = true;
    getPreview().then((v) => alive && setInfo(v));
    return () => {
      alive = false;
    };
  }, []);
  return info;
};
